__turbopack_context__.v({
  "amountContainer": "DonationFeedItem-module__LMbxRq__amountContainer",
  "card": "DonationFeedItem-module__LMbxRq__card",
  "clickArea": "DonationFeedItem-module__LMbxRq__clickArea",
  "comment": "DonationFeedItem-module__LMbxRq__comment",
  "commentContainer": "DonationFeedItem-module__LMbxRq__commentContainer",
  "expanded": "DonationFeedItem-module__LMbxRq__expanded",
  "header": "DonationFeedItem-module__LMbxRq__header",
  "noComment": "DonationFeedItem-module__LMbxRq__noComment",
  "secondSlotWrapper": "DonationFeedItem-module__LMbxRq__secondSlotWrapper",
  "showMoreButton": "DonationFeedItem-module__LMbxRq__showMoreButton",
  "skeletonContainer": "DonationFeedItem-module__LMbxRq__skeletonContainer",
  "timestamp": "DonationFeedItem-module__LMbxRq__timestamp",
});
